// Custom hook for managing form editing state
import { useCallback, useState } from "react";

export function useEditing(defaults){
  // State for currently editing item
  const [editing, setEditing] = useState(null);

  // Open modal for creating new item
  const openNew = useCallback(()=>setEditing({ ...defaults }), [defaults]);

  // Open modal for editing existing item
  const openEdit = useCallback((row)=>setEditing({ ...row }), []);

  // Close modal
  const close = useCallback(()=>setEditing(null), []);

  return { 
    editing,
    setEditing,
    openNew,
    openEdit,
    close
  };
}
